import { request } from '../core';
import { Method } from '../core/util';

class SingleViewApis {
  fetchDomain = `${location.protocol}//${process.env.JDX_APP_CLOUD_FETCH_DOMAIN}`;
  public static fetchVehicleInfo = async (license: string) => {
    const requestParam: RequestOptions = {
      method: Method.POST,
      path: `/monitor/web/basic/vehicle`,
      body: {
        vehicleName: license,
      },
    };
    return request(requestParam);
  };

  /** 呼叫一线：获取一线人员列表 */
  public getAttentionUser = async (vehicleName: string) => {
    const requestOption: RequestOptions = {
      path: `/monitor/web/attention/getAttentionUser`,
      method: Method.POST,
      body: {
        vehicleName,
      },
    };
    return request(requestOption);
  };

  /** 呼叫一线：获取一线人员手机号明文 */
  public getAttentionUserPhone = async (vehicleName: string) => {
    const requestOption: RequestOptions = {
      absoluteURL: `${this.fetchDomain}/monitor/web/attention/getStationPersonPhone`,
      method: Method.POST,
      body: {
        vehicleName,
      },
      headers: {
        'LOP-DN': process.env.JDX_APP_REQUEST_HEADER!,
      },
    };
    return request(requestOption);
  };
  /**
   * 获取地图升级详情
   * @param {string} vehicleName
   * @return {Promise}
   */
  public getMapUpdateDetail = async (vehicleName: string): Promise<any> => {
    const requestParam: RequestOptions = {
      path: '/ota/server/get_vehicle_progress',
      method: Method.POST,
      body: {
        vehicleName: vehicleName,
        appNameList: ['map'],
      },
    };
    return request(requestParam);
  };

  /**
   * 将地图转为静默下载
   * @param {string} vehicleName
   * @return {Promise}}
   */
  public confirmSilentUpdate = async (vehicleName: string): Promise<any> => {
    const requestParam: RequestOptions = {
      path: `/monitor/web/ota/mapSilentDownload`,
      method: Method.POST,
      body: {
        vehicleName,
      },
    };
    return request(requestParam);
  };
}

export default SingleViewApis;
